import * as t from 'io-ts';
import { omit } from 'lodash-es';

export const bookingInquiryDraft = t.type({
  form_step_index: t.number,
  step: t.string, // Right now, step other than InquiryForm is not supported
  data: t.unknown,
  updated_at: t.string,
  created_at: t.string,
});

export type BookingInquiryDraft = t.TypeOf<typeof bookingInquiryDraft>;

export const postBookingInquiryDraft = t.type(
  omit(bookingInquiryDraft.props, ['updated_at', 'created_at']),
);

export type PostBookingInquiryDraft = t.TypeOf<typeof postBookingInquiryDraft>;
